import React from "react";
import { InputElement } from "../../shared/FormElements";
import { SiteConstants } from "../../../constants/constant";

const ForgotPasswordInit = props => {
  if (props.sucessState) {
    props.lazyLoadComponent(props.nextPage);
  }
  const sendApiHit = () => {
    props.sucessHandler(props.formName);
  };
  const handleEnterKey = event => {
    const eventCode = event.which || event.keyCode;
    if (eventCode === SiteConstants.ENTER_KEY_EVENT_CODE) {
      sendApiHit();
    }
  };
  const forgotPasswordStructure = props.form.map((value, index) => (
    <div
      key={value + index}
      className="d-flex justify-content-center no-gutter"
    >
      <InputElement
        name={value.id}
        type={value.config.type}
        class="mb-3 col-12 form-group mt-20"
        label={value.config.label}
        required={value.config.validation.require}
        value={value.config.value}
        onChangeHandler={props.onChangeHandler}
        formName={props.formName}
        onBlurHandler={props.onBlurHandler}
        errorMsg={value.config.errorMsg}
        valid={value.config.valid}
        maxLength={value.config.maxLength}
        placeholder={value.config.placeholder ? value.config.placeholder : ""}
        belowPlaceholder={
          value.config.belowPlaceholder ? value.config.belowPlaceholder : ""
        }
      />
    </div>
  ));
  return (
    <React.Fragment>
      <div className="text-center mt50">
        {props.resetPasswordMessage && (
          <p className="error">{props.resetPasswordMessage}</p>
        )}
        <h3>Create a new password</h3>
        <p className="subHeading">Set a new password for your ausbiz account</p>
      </div>
      <div>{forgotPasswordStructure}</div>
      <div className="mt75">
        <button
          onKeyPress={event => handleEnterKey(event)}
          type="button"
          className="btn resetButton"
          disabled={props.btnDisabled ? "disabled" : ""}
          onClick={() => sendApiHit()}
        >
          Reset password
        </button>
      </div>
    </React.Fragment>
  );
};

export default ForgotPasswordInit;
